import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Stack, Typography } from '@mui/material';
import { useTheme } from '@mui/material/styles';

import { CareInfoDisplayItem } from 'src/constants/ResidentCareInfoValues';

interface ResidentCareInfoProps {
    careInfoDisplays: CareInfoDisplayItem[];
}

function ResidentCareInfo(props: ResidentCareInfoProps) {
    const { careInfoDisplays } = props;

    const theme = useTheme();

    return (
        <Stack data-dd-privacy="mask" sx={{ gap: 1 }}>
            {careInfoDisplays.map(({ key, icon, label, subLabel }) => (
                <Stack key={key} direction="row" sx={{ alignItems: 'flex-start', gap: 1 }}>
                    {icon && (
                        <FontAwesomeIcon
                            icon={icon}
                            color={theme.palette.text.primary}
                            size="lg"
                            fixedWidth
                        />
                    )}
                    <Stack>
                        <Typography variant="body2" color="textPrimary">
                            {label}
                        </Typography>
                        {subLabel && (
                            <Typography variant="body2" color="textSecondary">
                                {subLabel}
                            </Typography>
                        )}
                    </Stack>
                </Stack>
            ))}
        </Stack>
    );
}

export default ResidentCareInfo;
